import { addMembershipSignOutHook } from "@/actions/hooks";

const disneyDriver = {
  listingId: null,
  oneId: null,
  oneIdConfig: null,
  onInitialized: null,
  submitMembershipData: null,

  // Submit button click
  submit() {
    return new Promise((resolve, reject) => {
      if (this.oneId) {
        //Get logged in status
        this.oneId.getLoggedInStatus().then((isLoggedIn) => {
          if (!isLoggedIn) {
            this.oneId.launchLogin().then(() => {
              resolve({isLoading: false}); // Enable the submit button
            });
          } else {
            this.oneId.getGuest(false).then((guest) => {
                this.onOneIDLogin(guest);
                resolve({isLoading: true}); // Submit button should be disabled
              }
            );
          }
        });
      } else {
        reject(new Error('OneID is not available'));
      }
    });
  },

  // Init
  init(listingConfig, membershipConfig, onInitialized, submitMembershipData, dispatch) {
    const env = membershipConfig?.additional_parameters?.environment || '';
    this.oneIdConfig = {
      clientId: membershipConfig?.additional_parameters?.clientId,
      responderPage: new URL(
        `/js/membership/disney/responder${env === 'STAGE' ? '-stg' : ''}.html`,
        listingConfig?.partnerUrl
      ).toString(),
      environment: env,
      debug: false,
    };
    this.listingId = listingConfig.listingId;
    this.onInitialized = onInitialized;
    this.submitMembershipData = submitMembershipData;

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src =
        this.oneIdConfig.environment === 'STAGE'
          ? 'https://stg.cdn.registerdisney.go.com/v4/OneID.js'
          : 'https://cdn.registerdisney.go.com/v4/OneID.js';
      script.async = true;
      script.onload = () => {
        try {
          this.oneId = window.OneID.get(this.oneIdConfig);
          this.oneId.init();
        } catch (e) {
          // If already initialized
          this.oneId = window.OneID.get();
        }

        // init block
        if (this.oneId) {
          this.oneId.on('init', (init) => this.onOneIDInit(init));
          this.oneId.on('login',(guest) =>  this.onOneIDLogin(guest));
          this.oneId.on('logout',() => this.onOneIDLogout());
          this.oneId.on('error',() => this.onOneIDError());

          // Handle logout
          dispatch(addMembershipSignOutHook(() => {
            this.oneId.logout();
          }));

          resolve();
        } else {
          reject(new Error('OneID is not available'));
        }
      };
      document.body.appendChild(script);
    });
  },

  onOneIDInit(init) {
    if (init.loggedIn) {
      this.oneId.getGuest(false).then((guest) => this.onOneIDLogin(guest));
    }
    if (this.onInitialized) {
      this.onInitialized();
    }
  },

  onOneIDLogin(guest) {
    if (guest) {
      const membershipData = {
        listingId: this.listingId,
        membership: {
          submit_member: 'submit_member',
          swid: guest.profile.swid,
          disney_token: guest.token.access_token,
          id_token: guest.token.access_token,
        }
      };
      if (this.submitMembershipData) {
        this.submitMembershipData(membershipData);
      }
    }
  },

  onOneIDLogout() {},
  onOneIDError() {}
}
export default disneyDriver;
